import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../common/components/table";
import PageLoader from "../../../../../components/PageLoader";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectBatchLogsListItems } from "../../../../../redux/batch-logs/selector";
import { batchLogs } from "../../../../../redux/batch-logs/action";


const ManagementBatchLogs = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)

    const itemsData = useSelector(selectBatchLogsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Message', headerName: 'Message' },
          { field: 'Level', headerName: 'Level' },
          { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat:true },
          { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat:true }
      
        ]);
      }
     
      const fetchBatchLogs=()=>{
        dispatch(batchLogs.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/batch-logs/list`,entity:'batchLogs',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchBatchLogs()
	}, [pageData])

	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
		<Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
    paginationData={itemsData?.result?.pagination}  headingName="Batch logs"/>
     
  }
  </>
	);
};

export default ManagementBatchLogs;


